// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@100..900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand: "selforder";
  --main-background: #000;
  --input-background: #353535;
  --ion-color-gray-light: #F5F5F5;
  --ion-color-gray-dark: #D4D4D4;
  --ion-color-gray-darkest: #1F1B1C;
  --ion-color-black: #000000;
  --ion-color-subtitle: #B0B0B0;
  --ion-color-gold: #A38A5F;
  --accent-color: #925C49;
  --background-color: #fff;
  --background-toolbar-color: #fff;
  --color-h: var(--ion-color-black);
  --color-p-span: var(--ion-color-subtitle);
  --buttons-border-radius: 16px;
  --buttons-font-family: AppFontBold, sans-serif;
  --buttons-font-size: 18px;
  --buttons-text-transform: uppercase;
  --buttons-text-color: white;
  --account-toolbar-background: var(--color-background-alt);
  --text-color: #2C2C31;
  --home-page-card-backround: white;
  --home-page-language-switcher-color-selected: #2C2C31;
  --home-page-info-font-size: 18px;
  --home-page-card-borde-radius: 0px;
  --home-page-card-box-shadow: none;
  --item-view-background-color: #fff;
  --item-view-box-shadow: 0px 4px 15px 0px #4F614F26;
  --item-view-border: 0.5px solid rgba(235, 228, 222, 0.5);
  --item-view-title-font-size: 14px;
  --item-view-title-line-height: 17px;
  --item-view-info-font-size: 12px;
  --item-view-info-line-height: 13px;
  --modal-info-title-font-size: 28px;
  --modal-info-title-line-height: 33px;
  --modal-info-desc-font-size: 14px;
  --modal-info-desc-line-height: 18px;
  --modal-info-button-font-size: 16px;
  --modal-info-button-text-color: #fff;
  --order-toolbar-color: var(--background-toolbar-color);
  --order-toolbar-title-font-size: 14px;
  --order-toolbar-title-line-height: 17px;
  --order-list-title-font-size: 16px;
  --order-list-title-line-height: 19px;
  --order-list-option-name-font-size: 12px;
  --order-list-option-name-line-height: 13px;
  --order-list-option-name-color: var(--ion-color-subtitle);
  --order-list-article-price-font-size: 14px;
  --order-list-oarticle-price-line-height: 20px;
  --order-list-order-item-border: var(--item-view-border);
  --promo-code-border: var(--item-view-border);
  box-shadow: var(--item-view-box-shadow);
  --order-page-add-text-font-size: 12px;
  --order-page-add-text-line-height: 14px;
  --order-page-add-text-boroder: 2px solid #E53238;
  --order-page-add-text-border-radius: 50px;
  --order-page-footer-btn-text-font-size: 16px;
  --order-page-footer-btn-text-line-height: 19px;
  --menu-modal-name-color: var(--ion-color-primary);
  --highlight-color:#925C49;
  --quantity-selector-border-width: 1px;
  --quantity-selector-border-color: black;
  --quantity-selector-height: 30px;
  --quantity-selector-background: #fff;
  --quantity-selector-text-color: var(--ion-color-primary);
  --home-preorder-type-button-background: var(--ion-color-primary);
  --preorder-type-chip-border-color: white;
  --payment-modal-item-background: white;
  --payment-modal-checkbox-color: black;
  --ion-backdrop-color: #EBDFDAB2;
  --ion-backdrop-opacity: 0.9;
  --border-radius: 10px;
  --box-shadow: none;
  --custom-border-radius: 16px;
  --not-active-btn: #EBDFDA;
  --primary-btn: #FC5E07;
}

.ion-color-black {
  --ion-color-base: var(--ion-color-primary);
  --ion-color-base-rgb: var(--ion-color-black);
  --ion-color-contrast: var(--ion-color-main-contrast);
  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);
  --ion-color-shade: var(--ion-color-main-shade);
  --ion-color-tint: var(--ion-color-main-tint);
}

.fs-xs {
  font-size: 10px;
}

.fs-sm {
  font-size: 12px;
}

.fs-md {
  font-size: 14px;
}

.fs-base {
  font-size: 16px;
}

.fs-lg {
  font-size: 18px;
}

.fs-xl {
  font-size: 20px;
}

.fs-xl_2 {
  font-size: 22px;
}

.fs-xl_3 {
  font-size: 28px;
}

.fs-xl_4 {
  font-size: 30px;
}

.fs-hero {
  font-size: 40px;
}

.fw-rg {
  font-weight: 400;
}

.fw-md {
  font-weight: 500;
}

.fw-b {
  font-weight: 600;
}

.fw-b2 {
  font-weight: 700;
}

h1 {
  font-size: 40px;
  font-weight: 500;
  color: var(--accent-color) !important;
}

h2 {
  font-size: 30px;
  font-weight: 500;
}

h3 {
  font-size: 28px;
  font-weight: 600;
}

h4 {
  font-size: 22px;
  font-weight: 600;
}

ion-button, h5 {
  font-size: 20px;
  font-weight: 600;
}

:root {
  --ion-padding: 12px;
}

.form-row {
  height: 100%;
}
.form-row > ion-col {
  height: 100%;
}

swiper-container {
  height: 100%;
}

.margin-top-value {
  margin-top: 10px;
}

ion-slides {
  width: 100% !important;
  height: 100% !important;
}

swiper-slide {
  overflow: auto;
}

.wrapper-basket {
  min-height: 0;
  overflow: scroll;
  display: flex;
  flex: 1;
  flex-direction: column;
  border-right: 1px solid var(--color-black);
}
.wrapper-basket .footer {
  border-top: 1px solid var(--color-black);
  padding-top: 10px;
  width: 100%;
}
.wrapper-basket .footer.footer-block {
  padding: 20px;
}
.wrapper-basket .footer ion-button {
  width: 100%;
}

.tips {
  border-bottom: 1px solid var(--color-black);
  padding: 0 20px 10px;
}

.form-card {
  padding: 20px;
  position: relative;
  min-height: 0;
  overflow: scroll;
  display: flex;
  overflow-x: hidden;
  flex: 1;
  flex-direction: column;
}
.form-card .cross-icon {
  z-index: 5;
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.form-card .cross-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.form-card .cross-icon:hover {
  background: #f2dbd9;
}
.form-card .title {
  padding: 10px 0px;
  font-size: 20px;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
}
@media (min-width: 991px) {
  .form-card .title {
    margin-bottom: 30px;
  }
}
.form-card .wrapper-for-inputs {
  flex-grow: 1;
}
.form-card .footer {
  background: var(--ion-color-black);
  width: 100%;
}
.form-card .footer ion-button {
  width: 50%;
}
.form-card .footer div {
  height: 60px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.footer {
  background: var(--ion-color-black);
}
.footer ion-button {
  width: 100%;
}
.footer.acc {
  border-top: 1px solid var(--accent-color);
  border-radius: 24px;
}

.footer-btn {
  width: 50%;
  margin-bottom: 20px;
}

.button-row {
  padding: 20px 10px 20px 20px;
}
.button-row .sub-total {
  padding: 0 0 10px;
}
.button-row .total {
  padding: 0;
}
.button-row .total p {
  font-weight: 700;
  font-size: 18px;
}

.error_container {
  height: 12px;
  position: relative;
  margin-bottom: 5px;
  margin-top: 5px;
}

.input_group {
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  gap: 10px;
  align-items: center;
}
.input_group--1 {
  grid-column: span 8;
}
.input_group--2 {
  grid-column: span 4;
}

.error-phone, .error-email {
  left: 18px;
}
.error-phone .input_info, .error-email .input_info {
  position: absolute;
  top: 0;
}

.table {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px 30px;
}
.table .label {
  color: #aaa;
  font-size: 14px;
}
.table .value {
  text-align: right;
  justify-self: end;
  font-size: 14px;
}

.order-info, .order-list {
  padding: 12px;
  margin: 10px 15px;
  border-radius: 10px;
  border: 1px solid var(--accent-color);
}
.order-info .title, .order-list .title {
  padding: 12px 0;
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2705882353);
}
.order-info .title .edit-icon, .order-list .title .edit-icon {
  width: 22px;
  height: 22px;
  background: var(--accent-color);
  display: flex;
  padding: 4.5px;
  border-radius: 4px;
}

ion-textarea {
  background: #353535;
  height: 130px;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  --padding-start: 12px;
  --padding-top: 12px;
  --padding-end: 12px;
  --border-color: none!important;
  --highlight-color: #fff!important;
}

.terms-checkbox {
  margin-right: 12px;
  --size: 20px;
  --checkbox-background-checked: var(--accent-color);
  --checkmark-color: white;
  --border-radius: 4px;
  --border-color-checked: var(--accent-color);
}

ion-label {
  font-size: 14px;
  font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/theme/variables.scss","webpack://./src/app/components/checkout-modal/checkout-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAMA;EACE,oBAAA;EAEA,uBAAA;EACA,2BAAA;EAEA,+BAAA;EACA,8BAAA;EACA,iCAAA;EAEA,0BAAA;EACA,6BAAA;EACA,yBAAA;EAGA,uBAAA;EACA,wBAAA;EACA,gCAAA;EACA,iCAAA;EACA,yCAAA;EACA,6BAAA;EACA,8CAAA;EACA,yBAAA;EACA,mCAAA;EACA,2BAAA;EACA,yDAAA;EACA,qBAAA;EAEA,iCAAA;EACA,qDAAA;EACA,gCAAA;EACA,kCAAA;EACA,iCAAA;EAIE,kCAAA;EACA,kDAAA;EACA,wDAAA;EAEA,iCAAA;EACA,mCAAA;EAEA,gCAAA;EACA,kCAAA;EAKA,kCAAA;EACA,oCAAA;EAEA,iCAAA;EACA,mCAAA;EAEA,mCAAA;EACA,oCAAA;EAME,sDAAA;EACA,qCAAA;EACA,uCAAA;EAIA,kCAAA;EACA,oCAAA;EAEA,wCAAA;EACA,0CAAA;EACA,yDAAA;EAEA,0CAAA;EACA,6CAAA;EAEA,uDAAA;EAIF,4CAAA;EACA,uCAAA;EAIA,qCAAA;EACA,uCAAA;EACA,gDAAA;EACA,yCAAA;EAEA,4CAAA;EACA,8CAAA;EAGJ,iDAAA;EAEE,yBAAA;EAIA,qCAAA;EACA,uCAAA;EACA,gCAAA;EACA,oCAAA;EACA,wDAAA;EACA,gEAAA;EACA,wCAAA;EAEA,sCAAA;EACA,qCAAA;EAEA,+BAAA;EACA,2BAAA;EACA,qBAAA;EACA,kBAAA;EACA,4BAAA;EACA,yBAAA;EACA,sBAAA;AC/CF;;ADiDA;EACE,0CAAA;EACA,4CAAA;EACA,oDAAA;EACA,4DAAA;EACA,8CAAA;EACA,4CAAA;AC9CF;;ADyEE;EACE,eAtBS;AChDb;;ADqEE;EACE,eAtBS;AC5Cb;;ADiEE;EACE,eAtBS;ACxCb;;AD6DE;EACE,eAtBS;ACpCb;;ADyDE;EACE,eAtBS;AChCb;;ADqDE;EACE,eAtBS;AC5Bb;;ADiDE;EACE,eAtBS;ACxBb;;AD6CE;EACE,eAtBS;ACpBb;;ADyCE;EACE,eAtBS;AChBb;;ADqCE;EACE,eAtBS;ACZb;;ADuCE;EACE,gBAfW;ACrBf;;ADmCE;EACE,gBAfW;ACjBf;;AD+BE;EACE,gBAfW;ACbf;;AD2BE;EACE,gBAfW;ACTf;;AD6BA;EACE,eAAA;EACA,gBAAA;EACA,qCAAA;AC1BF;;AD4BA;EACE,eAAA;EACA,gBAAA;ACzBF;;AD4BA;EACE,eAAA;EACA,gBAAA;ACzBF;;AD2BA;EACE,eAAA;EACA,gBAAA;ACxBF;;AD2BA;EACE,eAAA;EACA,gBAAA;ACxBF;;AAtKA;EACC,mBAAA;AAyKD;;AAvKA;EACC,YAAA;AA0KD;AAxKC;EACC,YAAA;AA0KF;;AAvKA;EACC,YAAA;AA0KD;;AAxKA;EACC,gBAAA;AA2KD;;AAzKA;EACC,sBAAA;EACA,uBAAA;AA4KD;;AAzKA;EACC,cAAA;AA4KD;;AA1KA;EACC,aAAA;EACA,gBAAA;EACG,aAAA;EACH,OAAA;EACG,sBAAA;EACH,0CAAA;AA6KD;AA3KC;EACC,wCAAA;EACA,iBAAA;EACA,WAAA;AA6KF;AA5KE;EACC,aAAA;AA8KH;AA5KE;EACC,WAAA;AA8KH;;AAzKA;EACC,2CAAA;EACA,oBAAA;AA4KD;;AAzKA;EACC,aAAA;EACA,kBAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;EACA,OAAA;EACG,sBAAA;AA4KJ;AA3KC;EACC,UAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EAEA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AA4KF;AA3KE;EACC,WAAA;EACA,YAAA;EACA,WAAA;AA6KH;AA3KE;EACC,mBAAA;AA6KH;AA1KC;EACC,iBAAA;EACA,eAAA;EACA,oCAAA;EACA,yBAAA;AA4KF;AClQE;EDkFD;IAME,mBAAA;EA8KD;AACF;AA3KC;EACC,YAAA;AA6KF;AA3KC;EACC,kCAAA;EACA,WAAA;AA6KF;AA5KE;EACC,UAAA;AA8KH;AA5KE;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;AA8KH;;AAzKA;EACC,kCAAA;AA4KD;AA3KC;EACC,WAAA;AA6KF;AA3KC;EACC,yCAAA;EACA,mBAAA;AA6KF;;AAzKA;EACC,UAAA;EACA,mBAAA;AA4KD;;AAzKA;EACC,4BAAA;AA4KD;AA1KC;EACC,iBAAA;AA4KF;AAzKC;EACC,UAAA;AA2KF;AA1KE;EACC,gBAAA;EACA,eAAA;AA4KH;;AAvKA;EACC,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;AA0KD;;AAtKA;EACC,aAAA;EACC,sCAAA;EACA,SAAA;EACA,mBAAA;AAyKF;AAvKC;EACG,mBAAA;AAyKJ;AAtKE;EACE,mBAAA;AAwKJ;;AArKA;EACI,UAAA;AAwKJ;AAvKC;EACC,kBAAA;EACA,MAAA;AAyKF;;AArKA;EACC,aAAA;EACA,+BAAA;EACA,cAAA;AAwKD;AAtKC;EACC,WAAA;EACA,eAAA;AAwKF;AArKC;EACC,iBAAA;EACA,iBAAA;EACA,eAAA;AAuKF;;AAnKA;EACC,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,qCAAA;AAsKD;AArKC;EACC,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0DAAA;AAuKF;AAtKE;EACC,WAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,cAAA;EACA,kBAAA;AAwKH;;AAnKA;EACC,mBAAA;EACA,aAAA;EACA,+BAAA;EACA,gCAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,iCAAA;AAsKD;;AAnKA;EACC,kBAAA;EACA,YAAA;EACA,kDAAA;EACA,wBAAA;EACA,oBAAA;EACA,2CAAA;AAsKD;;AApKA;EACC,eAAA;EACA,gBAAA;AAuKD","sourcesContent":["@use \"sass:map\";\n\n@import \"../theme/mixins\";\n@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@100..900&display=swap');\n\n\n:root {\n  --brand: 'selforder';\n\n  --main-background: #000;\n  --input-background: #353535;\n\n  --ion-color-gray-light: #F5F5F5;\n  --ion-color-gray-dark: #D4D4D4;\n  --ion-color-gray-darkest: #1F1B1C;\n\n  --ion-color-black:  #000000;\n  --ion-color-subtitle: #B0B0B0;\n  --ion-color-gold: #A38A5F;\n\n  //main variables\n  --accent-color: #925C49;\n  --background-color: #fff;\n  --background-toolbar-color: #fff;\n  --color-h: var(--ion-color-black);\n  --color-p-span: var(--ion-color-subtitle);\n  --buttons-border-radius: 16px;\n  --buttons-font-family: AppFontBold, sans-serif;\n  --buttons-font-size: 18px;\n  --buttons-text-transform: uppercase;\n  --buttons-text-color: white;\n  --account-toolbar-background: var(--color-background-alt);\n  --text-color: #2C2C31;\n  //home-page\n  --home-page-card-backround: white;\n  --home-page-language-switcher-color-selected: #2C2C31;\n  --home-page-info-font-size: 18px;\n  --home-page-card-borde-radius: 0px;\n  --home-page-card-box-shadow: none;\n\n\n    //item-view\n    --item-view-background-color: #fff;\n    --item-view-box-shadow: 0px 4px 15px 0px #4F614F26;\n    --item-view-border: 0.5px solid rgba(235, 228, 222, 0.5);\n\n    --item-view-title-font-size: 14px;\n    --item-view-title-line-height: 17px;\n\n    --item-view-info-font-size: 12px;\n    --item-view-info-line-height: 13px;\n    //item-view\n  //menu-page\n\n  //modal-info\n    --modal-info-title-font-size: 28px;\n    --modal-info-title-line-height: 33px;\n\n    --modal-info-desc-font-size: 14px;\n    --modal-info-desc-line-height: 18px;\n    \n    --modal-info-button-font-size: 16px;\n    --modal-info-button-text-color: #fff;\n\n  //modal-info\n\n  //order-page\n    //order-toolbar\n      --order-toolbar-color: var(--background-toolbar-color);\n      --order-toolbar-title-font-size: 14px;\n      --order-toolbar-title-line-height: 17px;\n    //order-toolbar\n\n    //order-list\n      --order-list-title-font-size: 16px;\n      --order-list-title-line-height: 19px;\n\n      --order-list-option-name-font-size: 12px;\n      --order-list-option-name-line-height: 13px;\n      --order-list-option-name-color: var(--ion-color-subtitle);\n\n      --order-list-article-price-font-size: 14px;\n      --order-list-oarticle-price-line-height: 20px;\n\n      --order-list-order-item-border: var(--item-view-border);\n    //order-list\n\n    //promo-code\n    --promo-code-border: var(--item-view-border);\n    box-shadow: var(--item-view-box-shadow);\n\n    //promo-code\n\n    --order-page-add-text-font-size: 12px;\n    --order-page-add-text-line-height: 14px;\n    --order-page-add-text-boroder: 2px solid #E53238;\n    --order-page-add-text-border-radius: 50px; \n\n    --order-page-footer-btn-text-font-size: 16px;  \n    --order-page-footer-btn-text-line-height: 19px;  \n  //order-page\n  \n--menu-modal-name-color: var(--ion-color-primary);\n\n  --highlight-color:#925C49;\n\n\n\n  --quantity-selector-border-width: 1px;\n  --quantity-selector-border-color: black;\n  --quantity-selector-height: 30px;\n  --quantity-selector-background: #fff;\n  --quantity-selector-text-color: var(--ion-color-primary);\n  --home-preorder-type-button-background: var(--ion-color-primary);\n  --preorder-type-chip-border-color: white;\n  \n  --payment-modal-item-background: white;\n  --payment-modal-checkbox-color: black;\n\n  --ion-backdrop-color:  #EBDFDAB2;\n  --ion-backdrop-opacity: 0.9;\n  --border-radius: 10px;\n  --box-shadow: none;\n  --custom-border-radius: 16px;\n  --not-active-btn: #EBDFDA;\n  --primary-btn: #FC5E07;\n}\n.ion-color-black {\n  --ion-color-base: var(--ion-color-primary);\n  --ion-color-base-rgb: var(--ion-color-black);\n  --ion-color-contrast: var(--ion-color-main-contrast);\n  --ion-color-contrast-rgb: var(--ion-color-main-contrast-rgb);\n  --ion-color-shade: var(--ion-color-main-shade);\n  --ion-color-tint: var(--ion-color-main-tint);\n}\n\n\n\n//fonts\n$font-sizes: (\n        xs: 10px,\n        sm: 12px,\n        md: 14px,\n        base: 16px,\n        lg: 18px,\n        xl: 20px,\n        xl_2: 22px,\n        xl_3: 28px,\n        xl_4: 30px,\n        hero: 40px\n);\n\n$font-weights: (\n        rg: 400,\n        md: 500,\n        b: 600,\n        b2: 700\n);\n\n@each $name, $value in $font-sizes {\n  .fs-#{$name} {\n    font-size: $value;\n  }\n}\n\n@each $name, $value in $font-weights {\n  .fw-#{$name} {\n    font-weight: $value;\n  }\n}\n\n\nh1 {\n  font-size: map.get($font-sizes, hero);\n  font-weight: map.get($font-weights, md);\n  color: var(--accent-color)!important;\n}\nh2 {\n  font-size: map.get($font-sizes, xl_4);\n  font-weight: map.get($font-weights, md);\n}\n\nh3 {\n  font-size: map.get($font-sizes, xl_3);\n  font-weight: map.get($font-weights, b);\n}\nh4 {\n  font-size: map.get($font-sizes, xl_2);\n  font-weight: map.get($font-weights, b);\n}\n\nion-button, h5 {\n  font-size: map.get($font-sizes, xl);\n  font-weight: map.get($font-weights, b);\n}\n","@import '../../../theme/mixins';\n@import '../../../theme/variables';\n\n:root {\n\t--ion-padding: 12px;\n}\n.form-row{\n\theight: 100%;\n\n\t& > ion-col {\n\t\theight: 100%;\n\t}\n}\nswiper-container {\n\theight: 100%;\n}\n.margin-top-value {\n\tmargin-top: 10px;\n  }\nion-slides {\n\twidth: 100% !important;\n\theight: 100% !important;\n}\n\nswiper-slide {\n\toverflow: auto;\n}\n.wrapper-basket {\n\tmin-height: 0;\n\toverflow: scroll;\n    display: flex;\n\tflex: 1;\n    flex-direction: column;\n\tborder-right: 1px solid var(--color-black);\n\n\t.footer {\n\t\tborder-top: 1px solid var(--color-black);\n\t\tpadding-top: 10px;\n\t\twidth: 100%;\n\t\t&.footer-block {\n\t\t\tpadding: 20px;\n\t\t}\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n\n.tips {\n\tborder-bottom: 1px solid var(--color-black);\n\tpadding: 0 20px 10px;\n}\n\n.form-card {\n\tpadding: 20px;\n\tposition: relative;\n\tmin-height: 0;\n\toverflow: scroll;\n\tdisplay: flex;\n\toverflow-x: hidden;\n\tflex: 1;\n    flex-direction: column;\n\t.cross-icon {\n\t\tz-index: 5;\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 35px;\n\t\theight: 35px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t\tion-icon {\n\t\t\twidth: 100%;\n\t\t\theight: 100%;\n\t\t\tmargin: 0px;\n\t\t}\n\t\t&:hover {\n\t\t\tbackground: #f2dbd9;\n\t\t}\n\t}\n\t.title {\n\t\tpadding: 10px 0px;\n\t\tfont-size: 20px;\n\t\tfont-family: AppFontBold, sans-serif;\n\t\ttext-transform: uppercase;\n\t\t@include desktop {\n\t\t\tmargin-bottom: 30px;\n\t\t}\n\t}\n\t\n\t.wrapper-for-inputs {\n\t\tflex-grow: 1;\n\t}\n\t.footer {\n\t\tbackground: var(--ion-color-black);\n\t\twidth: 100%;\n\t\tion-button {\n\t\t\twidth: 50%;\n\t\t}\n\t\tdiv {\n\t\t\theight: 60px;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n\t\t\tjustify-content: space-around;\n\t\t}\n\t}\n}\n\n.footer {\n\tbackground: var(--ion-color-black);\n\tion-button {\n\t\twidth: 100%;\n\t}\n\t&.acc {\n\t\tborder-top: 1px solid var(--accent-color);\n\t\tborder-radius: 24px;\n\t}\n}\n\n.footer-btn {\n\twidth: 50%;\n\tmargin-bottom: 20px;\n}\n\n.button-row {\n\tpadding: 20px 10px 20px 20px;\n\n\t.sub-total {\n\t\tpadding: 0 0 10px;\n\t}\n\n\t.total {\n\t\tpadding: 0;\n\t\tp {\n\t\t\tfont-weight: 700;\n\t\t\tfont-size: 18px;\n\t\t}\n\t}\n}\n\n.error_container {\n\theight: 12px;\n\tposition: relative;\n\tmargin-bottom: 5px;\n\tmargin-top: 5px;\n}\n\n\n.input_group {\n\tdisplay: grid;\n  grid-template-columns: repeat(12, 1fr); \n  gap: 10px;\n  align-items: center;\n\n\t&--1 {\n    grid-column: span 8;\n  }\n\n  &--2 {\n    grid-column: span 4;\n  }\n}\n.error-phone, .error-email {\n    left: 18px;\n\t.input_info {\n\t\tposition: absolute;\n\t\ttop: 0;\n\t}\n}\n\n.table {\n\tdisplay: grid;\n\tgrid-template-columns: auto 1fr;\n\tgap: 10px 30px;\n\n\t.label {\n\t\tcolor: #aaa;\n\t\tfont-size: map-get($font-sizes, 'md');\n\t}\n\n\t.value {\n\t\ttext-align: right;\n\t\tjustify-self: end;\n\t\tfont-size: map-get($font-sizes, 'md');\n\t}\n}\n\n.order-info, .order-list {\n\tpadding: 12px;\n\tmargin: 10px 15px;\n\tborder-radius: 10px;\n\tborder: 1px solid var(--accent-color);\n\t.title {\n\t\tpadding: 12px 0;\n\t\tdisplay: flex;\n\t\tmargin-bottom: 10px;\n\t\tjustify-content: space-between;\n\t\tborder-bottom: 1px solid #ffffff45;\n\t\t.edit-icon {\n\t\t\twidth: 22px;\n\t\t\theight: 22px;\n\t\t\tbackground: var(--accent-color);\n\t\t\tdisplay: flex;\n\t\t\tpadding: 4.5px;\n\t\t\tborder-radius: 4px;\n\t\t}\n\t}\n}\n\nion-textarea{\n\tbackground: #353535;\n\theight: 130px;\n\tborder-bottom-left-radius: 10px;\n\tborder-bottom-right-radius: 10px;\n\t--padding-start: 12px;\n\t--padding-top: 12px;\n\t--padding-end: 12px;\n\t--border-color: none!important;\n\t--highlight-color: #fff!important;\n}\n\n.terms-checkbox {\n\tmargin-right: 12px;\n\t--size: 20px;\n\t--checkbox-background-checked: var(--accent-color);\n\t--checkmark-color: white;\n\t--border-radius: 4px;\n\t--border-color-checked: var(--accent-color);\n}\nion-label {\n\tfont-size: map-get($font-sizes, \"md\");\n\tfont-weight: map-get($font-weights, \"b2\");\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
